/**
 * Append non-null/non-undefined params to a URL as a query string.
 *
 * - Scalars (string | number) are coerced to strings.
 * - Arrays are serialized as repeated parameters (`?key=a&key=b`) — empty arrays are skipped.
 * - Empty strings are kept (caller should filter falsy params upstream when needed).
 */
export function appendQuery(base, params) {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null)
            continue;
        if (Array.isArray(value)) {
            for (const v of value) {
                if (v === undefined || v === null)
                    continue;
                search.append(key, String(v));
            }
            continue;
        }
        search.set(key, String(value));
    }
    const qs = search.toString();
    return qs ? `${base}?${qs}` : base;
}
